import { html, LitElement } from "lit";
import { customElement } from 'lit/decorators.js';
import style from './usos-module-link-tile-container.scss';

/**
 * Container providing layout settings for `usos-module-link-tile`.
 *
 * @slot - Slot for tiles.
 */

@customElement('usos-module-link-tile-container')
export class UsosModuleLinkTileContainer extends LitElement {
    static override styles = style;

    constructor() {
        super();
        const internals = this.attachInternals();
        internals.role = 'list';
    }

    override render() {
        return html`
            <div>
                <slot></slot>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'usos-module-link-tile-container': UsosModuleLinkTileContainer
    }
}
